<!-- List of documents width actions -->
<ng-container *ngFor="let document of documents">
  <b class="default-font-size">{{ document.name }}</b>
  <ul class="d-none d-lg-block list-group mt-3 mb-4">
    <li class="list-group-item subheader d-block pt-1 pe-0 pb-1 ps-2">
      <div class="row w-100 d-flex p-0 align-items-center">
        <div class="col-5 firstcol text-truncate" translate="Request.Actions.Person"></div>
        <div class="col-6 text-truncate"><span translate="Request.Actions.Action"></span></div>
        <!-- <div class="col-2 text-truncate"><span *ngIf="hasDocumentOneOrMoreActions(document.id) && document.id" translate="Request.Actions.Type"></span></div>
        <div class="col-2 text-truncate"><span *ngIf="hasDocumentOneOrMoreActions(document.id) && document.id" translate="Request.Actions.Provider"></span></div> -->
        <div class="col-1 text-end">
          
          <div ngbDropdown class="dropdown float-end">
            <button class="btn btn-sm btn-success dropdown-toggle" [disabled]="checkForDisableAddActions(document.id)" type="button" id="dropdownMenu" ngbDropdownToggle>
              <span translate="Button.AddActions"></span>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownMenu">
              <ng-container *ngFor="let action of allowedActionsForDocument(document.id)">
                <button [disabled]="disableAction(action)" (click)="openActionDialog(document.id, action)" class="action" ngbDropdownItem translate="Button.{{action}}"></button>
              </ng-container>
            </div>
          </div>

        </div>
      </div>
    </li>
      <ng-container *ngFor="let person of displayActionsPerDocument(document.id); int let i = index; let firstitem = first; let lastitem = last;">
        <li class="list-group-item d-block pt-1 pe-0 pb-1 ps-2 subtable" [ngClass]="{ 'no-signaturefield-placed': DisplaySigningFieldNotPlaced(person, person.action, document) }">
          <app-action-table-document-actions [action]="person" [document]="document" [showPlaceButton]="DisplaySigningFieldNotPlaced(person, person.action, document)"></app-action-table-document-actions>
        </li>
      </ng-container>
  </ul>

</ng-container>

<!-- All documents -->
<ng-container *ngIf="allowDownloadActions">
  <app-action-table-all-documents [allDocumentsActions]="displayActionsPerDocument()"></app-action-table-all-documents>
</ng-container>